import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import FullPageLoader from '../components/ui/FullPageLoader'
import { CAMBIO_CLAVE_PATH } from './paths'

export default function ProtectedRoute() {
  const { isAuthorized, loading, debeCambiarClave } = useAuth()
  const location = useLocation()
  if (loading) return <FullPageLoader />
  if (!isAuthorized) return <Navigate to="/login" state={{ from: location }} replace />
  // Con contraseña temporal, cualquier ruta protegida lleva al cambio obligatorio.
  if (debeCambiarClave && location.pathname !== CAMBIO_CLAVE_PATH) return <Navigate to={CAMBIO_CLAVE_PATH} replace />
  return <Outlet />
}
